import { render, staticRenderFns } from "./pay-ok.vue?vue&type=template&id=8ae59674&scoped=true"
import script from "./pay-ok.vue?vue&type=script&lang=js"
export * from "./pay-ok.vue?vue&type=script&lang=js"
import style0 from "./pay-ok.vue?vue&type=style&index=0&id=8ae59674&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae59674",
  null
  
)

export default component.exports